import { LayoutGrid, List } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export type ViewMode = 'grid' | 'list'

// Shared grid/list segmented toggle, mirroring the Content Hub's inline pair so
// every library surface (Screens, Stop Screens, Audio) flips views the same way.
export default function ViewToggle({
  mode, onChange,
}: {
  mode: ViewMode
  onChange: (m: ViewMode) => void
}) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center rounded-lg border border-input bg-background overflow-hidden shrink-0">
      <button
        type="button"
        onClick={() => onChange('grid')}
        aria-pressed={mode === 'grid'}
        title={t('common.gridView', 'Grid view')}
        className={`h-9 px-2 flex items-center justify-center transition-colors ${
          mode === 'grid' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        <LayoutGrid className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={() => onChange('list')}
        aria-pressed={mode === 'list'}
        title={t('common.listView', 'List view')}
        className={`h-9 px-2 flex items-center justify-center transition-colors ${
          mode === 'list' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        <List className="w-4 h-4" />
      </button>
    </div>
  )
}
